import React from "react";
import ClassNames from "classnames";
import * as s from  "./s.module.scss";

const MultiItemBlockItem = ({ icon, title, titleSize, description }) => {
  const fontSize = {
    [s.titleSmall]: titleSize === "small"
  };

  return (
    <div className={s.multiItemBlockItem}>
      <div className={s.multiItemBlockItemWrapper}>
        <div className={s.icon}>{icon}</div>
        {title && <div className={ClassNames(s.title, fontSize)}>{title}</div>}
        {description && <p className={s.description}>{description}</p>}
      </div>
    </div>
  );
};

export default MultiItemBlockItem;
